import React, { useEffect, useState } from 'react';
import { DashboardService } from '../DashboardService';
import { Col, Row } from 'react-bootstrap';
import { LatestCampaignsList } from './LatestCampaignsList';
import { LatestUsersList } from './LatestUsersList';
import { FaBox, FaCheck, FaFileInvoiceDollar, FaReply, FaUser } from 'react-icons/fa';
import { ICampaignReview } from '../../../model/campaign/ICampaignReview';
import { ErrorToast } from '../../../utils/toasters';
import { CampaignReview } from './CampaignReview';
import { IDashboard } from '../../../model/dashboard/IDashboard';
import { DashboardStatisticCard } from './DashboardStatisticCard';
import { useSelector } from 'react-redux';
import { hasAccessRight } from '../../../utils/Functions';
import { AdminAclEnum } from '../../../enum/AdminAclEnum';

export function Dashboard() {
    const [statistics, setStatistics] = useState<IDashboard>();
    const [statisticsLoading, setStatisticsLoading] = useState(true);
    const [campaignReview, setCampaignReview] = useState<ICampaignReview[]>([]);
    const [campaignReviewLoading, setCampaignReviewLoading] = useState(true);
    const [triggerUpdate, setTriggerUpdate] = useState(false);
    const { user } = useSelector((states: any) => states.auth);

    useEffect(() => {
        DashboardService.getDashboard()
            .then(data => {
                setStatistics(data);
            })
            .catch(err => ErrorToast(err))
            .finally(() => setStatisticsLoading(false));
    }, []);

    useEffect(() => {
        DashboardService.getCampaignApproval()
            .then(response => {
                setCampaignReview(response as any);
            })
            .catch(err => ErrorToast(err))
            .finally(() => setCampaignReviewLoading(false));
    }, [triggerUpdate]);

    return (
        <>
            <h2 className="mb-4">Hi, {user.firstName ? user.firstName : 'Influence'}!</h2>
            <p>Welcome to influence.vision dashboard</p>
            <Row className="gap-y-4">
                <DashboardStatisticCard
                    cardName="Offers"
                    icon={<FaCheck />}
                    baseColor="primary"
                    items={statistics?.offers}
                    total={statistics?.offersTotal ?? 0}
                    styleCard="h-100"
                />
                <DashboardStatisticCard
                    cardName="Campaigns"
                    icon={<FaBox />}
                    baseColor="primary"
                    items={statistics?.campaigns}
                    total={statistics?.campaignsTotal ?? 0}
                    styleCard="h-100"
                />
                <DashboardStatisticCard
                    cardName="Registrations"
                    icon={<FaUser />}
                    baseColor="primary"
                    items={statistics?.mau}
                    total={statistics?.mauTotal ?? 0}
                    styleCard="h-100"
                />
                {hasAccessRight(AdminAclEnum.INVOICES) && (
                    <DashboardStatisticCard
                        cardName="Invoices"
                        icon={<FaFileInvoiceDollar />}
                        baseColor="primary"
                        items={statistics?.invoices}
                        total={statistics?.invoicesTotal ?? 0}
                        styleCard="h-100"
                    />
                )}
                {(hasAccessRight(AdminAclEnum.REPORT_ITEMS) || hasAccessRight(AdminAclEnum.REPORTING)) && (
                    <DashboardStatisticCard
                        cardName="Reports"
                        icon={<FaReply />}
                        baseColor="primary"
                        items={statistics?.reports}
                        total={statistics?.reportsTotal ?? 0}
                        styleCard="h-100"
                    />
                )}
            </Row>

            {(campaignReviewLoading || !!campaignReview?.length) && (
                <Row className="pt-3">
                    <Col md={12}>
                        <CampaignReview
                            campaignReview={campaignReview as ICampaignReview[]}
                            setTriggerUpdate={setTriggerUpdate}
                            isLoading={campaignReviewLoading}
                        />
                    </Col>
                </Row>
            )}

            <Row className="p-3 mb-5 justify-content-between">
                <LatestCampaignsList campaigns={statistics?.lastCampaigns ?? []} isLoading={statisticsLoading} />
                <LatestUsersList users={statistics?.lastUsers ?? []} isLoading={statisticsLoading} />
            </Row>
        </>
    );
}
